import { render, staticRenderFns } from "./accmant.vue?vue&type=template&id=60c97baf&scoped=true"
import script from "./accmant.vue?vue&type=script&lang=js"
export * from "./accmant.vue?vue&type=script&lang=js"
import style0 from "./accmant.vue?vue&type=style&index=0&id=60c97baf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c97baf",
  null
  
)

export default component.exports